import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Made in Bharat Badge - Brand identity component
 * Shows Indian origin with flag colors
 */

const BadgeMadeInBharat = ({ 
  size = 'md',
  className = '',
  variant = 'default', // default, minimal, expanded
}) => {
  const sizeClasses = {
    sm: 'text-[10px] px-2 py-0.5 gap-1',
    md: 'text-xs px-2.5 py-1 gap-1.5',
    lg: 'text-sm px-3 py-1.5 gap-2',
  };

  if (variant === 'minimal') {
    return (
      <span 
        className={cn(
          'inline-flex items-center font-medium text-brand-bharat',
          sizeClasses[size],
          className
        )}
        aria-label="Made in India"
      >
        🇮🇳
      </span>
    );
  }

  return (
    <span 
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        'bg-gradient-to-r from-orange-50 via-white to-green-50',
        'border border-gray-200 dark:border-gray-700',
        'text-gray-700 dark:text-gray-300',
        sizeClasses[size],
        className
      )}
      aria-label="Made in India"
    >
      <span className="w-1.5 h-3 rounded-sm bg-gradient-to-b from-orange-500 via-white to-green-600" aria-hidden="true" />
      <span>Made in Bharat</span>
    </span>
  );
};

export default BadgeMadeInBharat;
